class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.items = ``;
    this.cartItemsWrapper = document.querySelector(
      '#cart-notification-product'
    );
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );
    this.querySelectorAll('button[type="button"]')?.forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.cartHref = document.querySelector('#cart-icon-bubble');
    this.cartHref?.addEventListener('click', this.init.bind(this));
    this.cartCount = document.querySelector('#cart-count');
    this.cartShipping = document.querySelector('.bc-free-shipping-wrapper');
    this.shippingPrice = this.cartShipping?.getAttribute('data-price') + '00';
    this.shippingCurrency = this.cartShipping?.getAttribute('data-currency');
    this.lessPackaging = this.querySelector(
      'input[type="checkbox"]#less-packaging'
    );
    this.shippingInsurance = this.querySelector(
      'input[type="checkbox"]#shipping-insurance'
    );
    localStorage.setItem('removeInsurance', false);
    this.shippingInsuranceId = this.shippingInsurance?.value;
    if (
      this.shippingInsurance?.getAttribute('data-auto') === 'true' &&
      localStorage.getItem('visited') === null
    ) {
      this.insurance(this.shippingInsurance, true);
      localStorage.setItem('visited', true);
    }
    this.lessPackaging?.addEventListener('change', this.packaging.bind(this));
    this.shippingInsuranceId &&
      this.shippingInsurance?.addEventListener(
        'change',
        this.insurance.bind(this)
      );
  }

  init(event) {
    event.preventDefault();
    this.getCart();
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.querySelector('body').classList.add('no-overflow');
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    document.querySelector('body').classList.remove('no-overflow');
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  packaging(event) {
    let el = event.target;
    let data = {
      attributes: {},
    };

    if (!el) return;

    if (el?.checked) {
      el.value ? (data.note = el.value) : null;
      data.attributes.lessPackaging = true;
    } else {
      el.value ? (data.note = '') : null;
      data.attributes.lessPackaging = false;
    }

    this.updateItem(data);
  }

  insurance(event, first = false) {
    if (!event) return;
    if (first) return this.addItem(this.shippingInsuranceId);
    let el = event.target;
    if (el.checked) {
      this.addItem(this.shippingInsuranceId);
      localStorage.setItem('removeInsurance', false);
    } else {
      this.changeItem(this.shippingInsuranceId);
      localStorage.setItem('removeInsurance', true);
    }
  }

  updateItem(data) {
    this.notification.classList.add('loading');
    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => this.renderCart(data))
      .catch((e) => console.error(e))
      .finally(() => {
        this.cartItemsWrapper.innerHTML = this.items;
        this.notification.classList.remove('loading');
        this.removeBtnInit();
      });
  }

  addItem(id) {
    this.notification.classList.add('loading');
    fetch(`${routes.cart_add_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({ id: id, quantity: 1 }),
    })
      .then((response) => response.json())
      .then((data) => this.getCart(true))
      .catch((e) => console.error(e))
      .finally(() => {});
  }

  changeItem(id, childID, qty = 0) {
    this.notification.classList.add('loading');
    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({ id: id, quantity: qty }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (!childID || childID === 'undefined') return this.renderCart(data);
        let findGiftproducts = data.items.find(
          (item) => item.properties._gift_id === childID
        );
        findGiftproducts && findGiftproducts !== undefined
          ? this.renderCart(data)
          : this.changeItem(childID);
      })
      .catch((e) => console.error(e))
      .finally(() => {
        this.cartItemsWrapper.innerHTML = this.items;
        this.notification.classList.remove('loading');
        this.removeBtnInit();
      });
  }

  minusItem(event) {
    if (!event?.target) return;
    let el = event.target;
    let key = el.getAttribute('data-key');
    let qty = el.getAttribute('data-qty');
    let childId = el.getAttribute('data-child');
    let newQty = parseInt(qty) - 1;
    this.changeItem(key, childId, newQty);
  }

  plusItem(event) {
    if (!event?.target) return;
    let el = event.target;
    let key = el.getAttribute('data-key');
    let qty = el.getAttribute('data-qty');
    let childId = el.getAttribute('data-child');
    let newQty = parseInt(qty) + 1;
    this.changeItem(key, childId, newQty);
  }

  getCart(loading = true) {
    this.notification.classList.add('loading');
    this.open();
    fetch(`${routes.cart_url}`, { ...fetchConfigGet('javascript') })
      .then((response) => response.json())
      .then((data) => this.renderCart(data))
      .catch((e) => console.error(e))
      .finally(() => {
        this.removeBtnInit();
        loading ? this.notification.classList.remove('loading') : null;
      });
  }

  renderCart(data) {
    if (!data) return;
    this.items = '';
    this.getCartAttributes(data?.attributes);

    this.getSubtotalPrice(
      data.original_total_price,
      data.total_price,
      data.cart_level_discount_applications
    );
    this.getCartItemsCount(data?.item_count);

    var cart_total = data.original_total_price;
    var exlcuded_id =
      '44771087876338,45294018265330,45294018396402,45294018330866,37581119881380,37581119914148,37581119946916,37581119979684,37581120012452,37581120045220';
    data?.items?.map((item) => {
      console.log(item.variant_id + '-' + item.quantity);
      if (exlcuded_id.indexOf(item.variant_id) >= 0) {
        cart_total -= item.price * item.quantity;
      }
    });
    if (data?.items.length > 0 && cart_total == 0) {
      cart_total = 8500;
    }

    if (!data?.items?.length) {
      document.querySelector('.cart-upsells-wrapper').style.display = 'none';
      this.shippingPrice ? this.freeShippingBar(cart_total) : null;
      this.cartItemsWrapper.innerHTML = this.getNotProductMessage();
      return (this.items += this.getNotProductMessage());
    }

    data?.items?.map((item) => {
      this.items += this.renderItem(item);
    });

    this.cartItemsWrapper.innerHTML = this.items;
    this.removeBtnInit();
    this.shippingPrice ? this.freeShippingBar(cart_total) : null;

    if (data?.items.length > 0) {
      document.querySelector('.cart-upsells-wrapper').style.display = 'block';
      var upsell_id = data?.items[0].product_id;
      console.log(data?.items[0]);
      var upsell_handle = data?.items[0].handle;
      var target_collection = '/collections/all?view=upsells';

      if (data?.items.length == 2) {
        document.querySelector('.cart-humor-message').innerHTML =
          '👀 Oooo that looks soft...';
      } else if (data?.items.length > 2) {
        document.querySelector('.cart-humor-message').innerHTML =
          "✨ You're one click closer to cozy paradise!";
      } else if (upsell_handle == 'the-cuddle-puddle') {
        document.querySelector('.cart-humor-message').innerHTML =
          '💓 Oooh this is gonna be BIG!';
      } else if (upsell_handle == 'marsh-2-0') {
        document.querySelector('.cart-humor-message').innerHTML =
          "✨ You're gonna be blown away when you feel this!";
      } else if (upsell_handle == 'thesquish') {
        document.querySelector('.cart-humor-message').innerHTML =
          '☁️ Great choice! This pillow is cloud-nine comfort.';
      } else if (upsell_handle == 'shleepy') {
        document.querySelector('.cart-humor-message').innerHTML =
          '💞 Shleepy + you = the coziest duo ever.';
      } else if (upsell_handle == 'floof') {
        document.querySelector('.cart-humor-message').innerHTML =
          '🐾 Your fur baby is gonna love their new throne!';
      } else if (upsell_handle == 'lil-marsh-xs-pet') {
        document.querySelector('.cart-humor-message').innerHTML =
          '🐾 Nice choice. Your fur baby deserves the best, too!';
      } else if (upsell_handle == 'floof-pillow-bed') {
        document.querySelector('.cart-humor-message').innerHTML =
          '🐾 This is gonna be the best bed in the house!';
      } else if (upsell_handle == 'baby-onesie') {
        document.querySelector('.cart-humor-message').innerHTML =
          '🧡 Your little one’s first taste of UnHide softness!';
      } else if (upsell_handle == 'lil-marsh-lovey-blanket') {
        document.querySelector('.cart-humor-message').innerHTML =
          '🧡 Pure comfort for the tiniest hands!';
      } else if (upsell_handle == 'squish-back-rest') {
        document.querySelector('.cart-humor-message').innerHTML =
          '😇 Time to lean in! Your back will thank you.';
      } else if (upsell_handle == 'softie-socks') {
        document.querySelector('.cart-humor-message').innerHTML =
          '🧦 Looks like your ready to step up your sock game!';
      } else {
        document.querySelector('.cart-humor-message').innerHTML =
          '👀 Oooo that looks soft...';
      }

      if (
        upsell_handle == 'lil-marsh' ||
        upsell_handle == 'lusso-cloud-x-unhide-pelli' ||
        upsell_handle == 'squish-back-rest'
      ) {
        target_collection = '/collections/cart-upsell-1?view=upsells';
      } else if (
        upsell_handle == 'floof' ||
        upsell_handle == 'lil-marsh-xs-pet' ||
        upsell_handle == 'floof-pillow-bed'
      ) {
        target_collection = '/collections/cart-upsell-2?view=upsells';
      } else if (upsell_handle == 'netflix-lil-marsh') {
        target_collection = '/collections/cart-upsell-3?view=upsells';
      } else if (upsell_handle == 'thesquish' || upsell_handle == 'marsh-2-0') {
        target_collection = '/collections/cart-upsell-4?view=upsells';
      } else if (upsell_handle == 'braided-m-beige') {
        target_collection = '/collections/cart-upsell-5?view=upsells';
      } else if (
        upsell_handle == 'baby-onesie' ||
        upsell_handle == 'lil-marsh-lovey-blanket'
      ) {
        target_collection = '/collections/cart-upsell-6?view=upsells';
      } else if (upsell_handle == 'shleepy') {
        target_collection = '/collections/cart-upsell-7?view=upsells';
      } else if (data?.items[0].product_type == 'Bundles') {
        target_collection = '/collections/bundles?view=upsells';
      }
      fetch(window.location.origin + target_collection).then(
        async (response) => {
          var temp = document.createElement('html');
          temp.innerHTML = await response.text();
          data?.items.forEach((item) => {
            temp
              .querySelector(
                '.j-upsell-item[data-id="' + item.product_id + '"]'
              )
              ?.remove();
          });

          if (temp.querySelector('.j-upsell-item')) {
            document.querySelector('.cart-upsells-row').innerHTML =
              temp.querySelector('.j-upsell-items').innerHTML;
            // document.querySelectorAll('.cart-upsells-row .j-upsell-item').forEach(item=>{
            //   item.style.order = Math.floor(Math.random() * 20) + 1;
            // })
          }
        }
      );
    }
  }

  freeShippingBar(total) {
    if (this.cartShipping != null) {
      console.log(this.shippingCurrency.indexOf(Shopify.currency.active));
      if (this.shippingCurrency.indexOf(Shopify.currency.active) === -1) {
        this.cartShipping.classList.add('hidden');
        return;
      } else {
        this.cartShipping.classList.remove('hidden');
      }

      let el = this.querySelector('.bc-free-shipping-wrapper__text');
      let sucsess = this.querySelector(
        '.bc-free-shipping-wrapper__success-text'
      );
      let progressEl = this.querySelector('.bc-free-shipping-bar__progress');

      let shippingPriceCurrency = Currency.convert(
        this.shippingPrice,
        'USD',
        Shopify.currency.active
      );
      //let shippingPriceCurrency = this.shippingPrice;

      const _discount_steps = parseInt(
        document
          .querySelector('#cart-notification')
          .getAttribute('data-discount-steps')
      );
      var _discount_settings = [];
      for (let step = 1; step <= _discount_steps; step++) {
        let _discount_setting = [];
        let _discount_title = document
          .querySelector('#cart-notification')
          .getAttribute(`data-discount-title-${step}`);
        let _discount_price =
          parseInt(
            document
              .querySelector('#cart-notification')
              .getAttribute(`data-discount-price-${step}`)
          ) * 100;
        _discount_setting.push(_discount_title, _discount_price);
        _discount_settings.push(_discount_setting);
      }
      var max_price = Currency.convert(
        _discount_settings[_discount_settings.length - 1][1],
        'USD',
        Shopify.currency.active
      );
      if (total > 0) {
        if (total >= max_price) {
          if (_discount_settings.length == 1) {
            el.classList.remove('active');
            if (_discount_settings[0][0].indexOf('Shipping') < 0) {
              sucsess.querySelector('.active-dis-step').innerHTML =
                _discount_settings[_discount_settings.length - 1][0];
            }
          } else {
            if (_discount_settings[0][0].indexOf('Shipping') < 0) {
              sucsess.querySelector('.active-dis-step').innerHTML =
                _discount_settings[_discount_settings.length - 1][0];
            } else {
              sucsess.querySelector('.active-dis-step').innerHTML =
                '+ ' + _discount_settings[_discount_settings.length - 1][0];
            }
          }
          sucsess.classList.add('active');
          sucsess.classList.add('active-max');
          el.innerHTML =
            '<span class="remain-price"></span><span class="target-step"></span>You got ' +
            _discount_settings[_discount_settings.length - 1][0];
          progressEl ? (progressEl.style.width = '100%') : null;

          document.querySelectorAll('.discount-step-bar').forEach((item) => {
            item.setAttribute('style', '--progress:1');
          });
          document.querySelectorAll('.discount-step-point').forEach((item) => {
            item.classList.add('active');
          });

          document
            .querySelectorAll('.free-gift-item-wraper')
            .forEach((item) => {
              item.style.display = 'none';
              let item_id = item.getAttribute('data-id');
              let item_variant_id = item.getAttribute('data-variant-id');
              if (
                document.querySelector(
                  '.bc-cart__item[data-pd-id="' + item_id + '"]'
                )
              ) {
                if (item.nextElementSibling) {
                  setTimeout(function () {
                    document
                      .querySelector(
                        '.bc-cart__item[data-freegift="true"][data-pd-id="' +
                          item_id +
                          '"] .bc-cart__remove'
                      )
                      ?.click();
                    document
                      .querySelector(
                        '.bc-cart__item[data-freegift="true"][data-pd-id="' +
                          item_id +
                          '"] .bc-cart__remove'
                      )
                      ?.remove();
                  }, 300);
                } else {
                  item
                    .querySelector('.upd-add-btn')
                    .setAttribute('disabled', 'disabled');
                  item
                    .querySelectorAll('gift-variant-selects select')
                    .forEach((select) => {
                      select.setAttribute('disabled', 'disabled');
                    });
                  item.querySelector('gift-variant-selects').style.display =
                    'none';
                  item.querySelector('.upd-add-btn').style.display = 'none';
                  item.querySelector('product-form input').value = 0;
                  item.querySelector('.gift-remain-note').innerText =
                    'Congrats on your free gift!';
                }
              } else {
                item.querySelector('.upd-add-btn').removeAttribute('disabled');
                item
                  .querySelectorAll('gift-variant-selects select')
                  .forEach((select) => {
                    select.removeAttribute('disabled');
                  });
                item.querySelector('gift-variant-selects').style.display =
                  'block';
                item.querySelector('.upd-add-btn').style.display = 'block';
                if (item.querySelector('gift-variant-selects>*')) {
                  item
                    .querySelector('gift-variant-selects')
                    .dispatchEvent(new Event('change'), {
                      bubbles: true,
                      cancelable: true,
                    });
                } else {
                  item.querySelector('product-form input').value =
                    item_variant_id;
                }
                item.querySelector('.gift-remain-note').innerText =
                  'Please get your free gift';
              }
            });
          document.querySelector('.free-gift-item-wraper:last-child')
            ? (document.querySelector(
                '.free-gift-item-wraper:last-child'
              ).style.display = 'flex')
            : null;

          return;
        } else {
          sucsess.classList.remove('active-max');
          var check_step = true;
          if (_discount_steps == 1) {
            let current_step = Currency.convert(
              _discount_settings[0][1],
              'USD',
              Shopify.currency.active
            );
            if (total < current_step && check_step) {
              var newPrice = current_step - total; /* for free shipping */
              el.innerHTML =
                'Spend <span class="remain-price"></span> more to get <span class="target-step"></span>';
              let percent = (100 * total) / max_price;
              let priceEl = el?.querySelector('.remain-price');
              let targetEl = el?.querySelector('.target-step');
              progressEl ? (progressEl.style.width = percent + '%') : null;

              document
                .querySelectorAll('.discount-step-bar')
                .forEach((item) => {
                  item.setAttribute('style', '--progress:0');
                });
              document
                .querySelectorAll('.discount-step-point')
                .forEach((item) => {
                  item.classList.remove('active');
                });
              let point_1_price = Currency.convert(
                _discount_settings[0][1],
                'USD',
                Shopify.currency.active
              );
              let percent_1 = total / point_1_price;
              document
                .querySelector('.discount-step-bar.step-1')
                ?.setAttribute('style', '--progress:' + percent_1);

              priceEl
                ? (priceEl.innerHTML =
                    Shopify.formatMoney(newPrice).split('.')[0] +
                    ' ' +
                    Shopify.currency.active)
                : null; /* for free shipping */
              targetEl ? (targetEl.innerHTML = _discount_settings[0][0]) : null;
              sucsess.classList.remove('active');
              el.classList.add('active');
              return;
            }
          }
          for (let i = 1; i <= _discount_steps; i++) {
            let current_step = Currency.convert(
              _discount_settings[i - 1][1],
              'USD',
              Shopify.currency.active
            );

            if (total < current_step && check_step) {
              var newPrice = current_step - total; /* for free shipping */
              el.innerHTML =
                'Spend <span class="remain-price"></span> more to get <span class="target-step"></span>';
              let percent = (100 * total) / max_price;
              let priceEl = el?.querySelector('.remain-price');
              let targetEl = el?.querySelector('.target-step');
              progressEl ? (progressEl.style.width = percent + '%') : null;

              priceEl
                ? (priceEl.innerHTML =
                    Shopify.formatMoney(newPrice).split('.')[0])
                : null; /* for free shipping */
              targetEl
                ? (targetEl.innerHTML = _discount_settings[i - 1][0])
                : null;
              if (i > 2) {
                if (_discount_settings[0][0].indexOf('Shipping') < 0) {
                  sucsess.querySelector('.active-dis-step').innerHTML =
                    _discount_settings[i - 2][0];
                } else {
                  sucsess.querySelector('.active-dis-step').innerHTML =
                    '+ ' + _discount_settings[i - 2][0];
                }
              } else {
                if (_discount_settings[0][0].indexOf('Shipping') < 0) {
                  sucsess.querySelector('.active-dis-step').innerHTML =
                    _discount_settings[i - 2][0];
                } else {
                  sucsess.querySelector('.active-dis-step').innerHTML = '';
                }
              }

              var gift_claim = true;
              document
                .querySelectorAll('.free-gift-item-wraper')
                .forEach((item) => {
                  item.style.display = 'none';
                  let remain_price = item.getAttribute('data-price') * 100;
                  let item_id = item.getAttribute('data-id');
                  let item_variant_id = item.getAttribute('data-variant-id');
                  if (
                    document.querySelector(
                      '.bc-cart__item[data-pd-id="' + item_id + '"]'
                    )
                  ) {
                    if (total < remain_price) {
                      setTimeout(function () {
                        document
                          .querySelector(
                            '.bc-cart__item[data-freegift="true"][data-pd-id="' +
                              item_id +
                              '"] .bc-cart__remove'
                          )
                          ?.click();
                        document
                          .querySelector(
                            '.bc-cart__item[data-freegift="true"][data-pd-id="' +
                              item_id +
                              '"] .bc-cart__remove'
                          )
                          ?.remove();
                      }, 300);

                      return;
                    } else {
                      item
                        .querySelector('.upd-add-btn')
                        .setAttribute('disabled', 'disabled');
                      item.querySelector('.upd-add-btn').style.display = 'none';
                      item
                        .querySelectorAll('gift-variant-selects select')
                        .forEach((select) => {
                          select.setAttribute('disabled', 'disabled');
                        });
                      item.querySelector('gift-variant-selects').style.display =
                        'none';
                      item.querySelector('product-form input').value = 0;
                      item.querySelector('.gift-remain-note').innerText =
                        'You have free gift.';
                      item.previousElementSibling
                        ? (item.previousElementSibling.style.display = 'none')
                        : null;
                    }
                  } else {
                    if (total < remain_price) {
                      item
                        .querySelector('.upd-add-btn')
                        .setAttribute('disabled', 'disabled');
                      item
                        .querySelectorAll('gift-variant-selects select')
                        .forEach((select) => {
                          select.setAttribute('disabled', 'disabled');
                        });
                      //item.querySelector('gift-variant-selects').style.display='none';
                      item.querySelector('.upd-add-btn').style.display =
                        'block';
                      item.querySelector('product-form input').value = 0;
                      item.querySelector('.gift-remain-note').innerText =
                        'Spend ' +
                        Shopify.formatMoney(remain_price - total).split(
                          '.'
                        )[0] +
                        ' ' +
                        Shopify.currency.active +
                        ' more to unlock free gift';
                    } else {
                      if (item.previousElementSibling) {
                        setTimeout(function () {
                          document
                            .querySelector(
                              '.bc-cart__item[data-freegift="true"][data-pd-id="' +
                                item.previousElementSibling.getAttribute(
                                  'data-id'
                                ) +
                                '"] .bc-cart__remove'
                            )
                            ?.click();
                          document
                            .querySelector(
                              '.bc-cart__item[data-freegift="true"][data-pd-id="' +
                                item.previousElementSibling.getAttribute(
                                  'data-id'
                                ) +
                                '"] .bc-cart__remove'
                            )
                            ?.remove();
                        }, 300);
                      }
                      item
                        .querySelector('.upd-add-btn')
                        .removeAttribute('disabled');
                      item.querySelector('.upd-add-btn').style.display =
                        'block';
                      item
                        .querySelectorAll('gift-variant-selects select')
                        .forEach((select) => {
                          select.removeAttribute('disabled', 'disabled');
                        });
                      item.querySelector('gift-variant-selects').style.display =
                        'block';
                      if (item.querySelector('gift-variant-selects>*')) {
                        item
                          .querySelector('gift-variant-selects')
                          .dispatchEvent(new Event('change'), {
                            bubbles: true,
                            cancelable: true,
                          });
                      } else {
                        item.querySelector('product-form input').value =
                          item_variant_id;
                      }
                      item.querySelector('.gift-remain-note').innerText =
                        'Please get your free gift';
                      item.previousElementSibling
                        ? (item.previousElementSibling.style.display = 'none')
                        : null;
                      item.style.display = 'flex';
                      gift_claim = false;
                    }
                    if (
                      item.previousElementSibling &&
                      item.previousElementSibling.getAttribute('data-price') *
                        100 <
                        total &&
                      document.querySelector(
                        '.bc-cart__item[data-pd-id="' +
                          item.previousElementSibling.getAttribute('data-id') +
                          '"]'
                      )
                    ) {
                      item.style.display = 'flex';
                    }
                  }
                });

              if (i == 1) {
                document.querySelector('.free-gift-item-wraper.fgift-2')
                  ? (document.querySelector(
                      '.free-gift-item-wraper.fgift-2'
                    ).style.display = 'flex')
                  : null;
              } else {
                if (gift_claim) {
                  document.querySelector('.free-gift-item-wraper.fgift-' + i)
                    .previousElementSibling
                    ? (document.querySelector(
                        '.free-gift-item-wraper.fgift-' + i
                      ).previousElementSibling.style.display = 'none')
                    : null;
                  document.querySelector('.free-gift-item-wraper.fgift-' + i)
                    ? (document.querySelector(
                        '.free-gift-item-wraper.fgift-' + i
                      ).style.display = 'flex')
                    : null;
                }
              }

              el.classList.add('active');
              if (i == 1) {
                sucsess.classList.remove('active');
                let percent_sub = total / current_step;
                document
                  .querySelector('.discount-step-bar.step-' + i)
                  ?.setAttribute('style', '--progress:' + percent_sub);
                document
                  .querySelector('.discount-step-point.step-' + i)
                  ?.classList.remove('active');
              } else {
                sucsess.classList.add('active');
                let prev_step = Currency.convert(
                  _discount_settings[i - 2][1],
                  'USD',
                  Shopify.currency.active
                );
                let percent_sub =
                  (total - prev_step) / (current_step - prev_step);
                document
                  .querySelector('.discount-step-bar.step-' + i)
                  ?.setAttribute('style', '--progress:' + percent_sub);
                document
                  .querySelector('.discount-step-point.step-' + i)
                  ?.classList.remove('active');
              }
              check_step = false;
            } else {
              if (total >= current_step) {
                document
                  .querySelector('.discount-step-bar.step-' + i)
                  ?.setAttribute('style', '--progress:1');
                document
                  .querySelector('.discount-step-point.step-' + i)
                  ?.classList.add('active');
                sucsess.classList.add('active');
              } else {
                document
                  .querySelector('.discount-step-bar.step-' + i)
                  ?.setAttribute('style', '--progress:0');
                document
                  .querySelector('.discount-step-point.step-' + i)
                  ?.classList.remove('active');
              }
            }
          }
        }
      } else {
        sucsess.classList.remove('active-max');
        document.querySelectorAll('.discount-step-bar').forEach((item) => {
          item.setAttribute('style', '--progress:0');
        });
        document.querySelectorAll('.discount-step-point').forEach((item) => {
          item.classList.remove('active');
        });
        progressEl ? (progressEl.style.width = '0') : null;
        el.innerHTML =
          'Spend <span class="remain-price"></span> more to get <span class="target-step"></span>';
        let priceEl = el?.querySelector('.remain-price');
        let targetEl = el?.querySelector('.target-step');
        priceEl
          ? (priceEl.innerHTML = Shopify.formatMoney(
              shippingPriceCurrency
            ).split('.')[0])
          : null; /* for free shipping */
        targetEl ? (targetEl.innerHTML = _discount_settings[0][0]) : null;
        el.classList.add('active');
        sucsess.classList.remove('active');
        document.querySelectorAll('.free-gift-item-wraper').forEach((item) => {
          item.style.display = 'none';
          let remain_price = item.getAttribute('data-price') * 100;
          item
            .querySelector('.upd-add-btn')
            .setAttribute('disabled', 'disabled');
          item
            .querySelectorAll('gift-variant-selects select')
            .forEach((select) => {
              select.setAttribute('disabled', 'disabled');
            });
          //item.querySelector('gift-variant-selects').style.display='none';
          item.querySelector('.upd-add-btn').style.display = 'block';
          item.querySelector('product-form input').value = '0';
          item.querySelector('.gift-remain-note').innerText =
            'Spend ' +
            Shopify.formatMoney(remain_price).split('.')[0] +
            ' more to unlock free gift';
        });
        document.querySelector('.free-gift-item-wraper:first-child')
          ? (document.querySelector(
              '.free-gift-item-wraper:first-child'
            ).style.display = 'flex')
          : null;
      }
    }
  }

  // getCurrency(price, from = 'CAD', to = Shopify.currency.active){
  //   let currencyPrice = Currency.convert(price, from, to);
  //   return Shopify.formatMoney(currencyPrice) + ' ' + to;
  // }

  getCartAttributes(data) {
    if (!data || !this.lessPackaging) return;
    data?.lessPackaging === 'true' ? (this.lessPackaging.checked = true) : null;
  }

  getCartItemsCount(count) {
    if (!this.cartCount) return;
    this.cartCount.textContent = count;
    if (this.shippingInsurance != null) {
      if (
        count == 1 &&
        !this.shippingInsurance.checked &&
        localStorage.getItem('removeInsurance') == 'false'
      ) {
        this.insurance(this.shippingInsurance, true);
      } else if (count == 1 && this.shippingInsurance.checked) {
        this.shippingInsurance.click();
        this.shippingInsurance.checked = false;
        localStorage.setItem('removeInsurance', false);
      }
    }
  }

  renderItem(item) {
    jQuery.ajax({
      url: '/products/' + item.handle + '.js',
      dataType: 'json',
      async: false,
      success: function (product) {
        item['compare_at_price'] = 0;
        product.variants.forEach(function (variant) {
          if (
            variant.compare_at_price != null &&
            variant.id == item.variant_id
          ) {
            item['compare_at_price'] = variant.compare_at_price;
          }
        });
        console.log('line_item', item);
      },
    });
    const insuranceID = this.getInsurance(item.id);
    const giftID = item?.properties?._gift ? false : true;
    let htmlItem = `<div class="bc-cart__item" data-freegift="${this.checkFreeGiftItem(item?.properties)}" data-id="${item.id}" data-pd-id="${item.product_id}">`;
    htmlItem += `<div class="bc-cart__image-wrapper">${this.getImage(item.url, item.featured_image)}</div>`;
    htmlItem += `<div class="bc-cart__info-wrapper">
        ${this.getTitle(item?.url, item?.product_title, item?.variant_title)}
        <div class="bc-cart__price-and-properties">
          <div class="bc-cart__price-wrapper">
            ${this.getPrice(item.original_price, item.discounted_price, item.discounts, item.compare_at_price)}
          </div>
          <div class="bc-cart__properties-wrapper">
            ${this.getProperties(item?.properties)}
          </div>
        </div>
        ${this.getQuantity(insuranceID, giftID, item?.quantity, item.key, item?.properties?._gift_id, item.product_title)}`;

    if (insuranceID && giftID) {
      if (item?.properties?._gift_id) {
        htmlItem += `<span class="bc-cart__remove" data-key="${item.key}" data-child="${item?.properties?._gift_id}" role="button" data-track="click" data-track-event="Cart - Remove Item" data-track-detail="${(item.product_title || '').replace(/"/g, '&quot;')}">
              ${this.getRemoveIcon()}
            </span>`;
      } else {
        htmlItem += `<span class="bc-cart__remove" data-key="${item.key}" role="button" data-track="click" data-track-event="Cart - Remove Item" data-track-detail="${(item.product_title || '').replace(/"/g, '&quot;')}">
              ${this.getRemoveIcon()}
            </span>`;
      }
    }

    htmlItem += `</div>`;
    htmlItem += `</div>`;
    return htmlItem;
  }

  getInsurance(id) {
    if (!id || !this.shippingInsurance || !this.shippingInsuranceId)
      return true;
    this.shippingInsuranceId === id.toString()
      ? (this.shippingInsurance.checked = true)
      : null;
    return this.shippingInsuranceId === id.toString() ? false : true;
  }

  getImage(url, image) {
    return `<a href="${url}">
        <img class="bc-cart__image-img width-10" src="${image.url || 'https://cdn.shopify.com/s/files/1/0050/4335/5720/files/UnHide_MysteryGiftLaunch_f36ad746-773f-419e-b69e-16b77c7644f9.jpg?v=1760649167'}" alt="${image.alt || 'Product Image'}" />
      </a>`;
  }

  getTitle(url, productName, variantName) {
    let html = `<a href="${url}">`;
    html += `<h3 class="bc-cart__title">${productName}</h3>`;
    if (variantName && variantName !== 'null') {
      html += `<h6 class="bc-cart__variant-title">${variantName}</h6>`;
    }
    html += '</a>';
    return html;
  }

  getPrice(originalPrice, finalPrice, discount, compare_at_price) {
    let priceHtml =
      compare_at_price > finalPrice
        ? `<span class="bc-cart__price-sale">${Shopify.formatMoney(compare_at_price).replace('.00', '')}</span>`
        : ``;
    priceHtml += `<span class="bc-cart__price">${Shopify.formatMoney(finalPrice).replace('.00', '')}</span>`;
    if (discount?.length) {
      priceHtml += `<ul>`;
      discount.map((dis) => {
        priceHtml += `<li><svg focusable="false" width="10" height="10" class="icon icon--discount-badge   " viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.93734 1.1171C9.97075 0.521457 9.47854 0.0292498 8.88291 0.0626607L5.39562 0.258271C5.15016 0.27204 4.91836 0.375751 4.74452 0.549595L0.707107 4.58701C0.316582 4.97753 0.316583 5.6107 0.707107 6.00122L3.99878 9.29289C4.3893 9.68342 5.02247 9.68342 5.41299 9.29289L9.4504 5.25548C9.62425 5.08163 9.72796 4.84984 9.74173 4.60438L9.93734 1.1171ZM7.05882 2.94118C7.3837 3.26605 7.91042 3.26605 8.23529 2.94118C8.56017 2.6163 8.56017 2.08958 8.23529 1.76471C7.91042 1.43983 7.3837 1.43983 7.05882 1.76471C6.73395 2.08958 6.73395 2.6163 7.05882 2.94118Z" fill="currentColor"></path>
        </svg> ${dis?.title} (-${Shopify.formatMoney(dis?.amount)})</li>`;
      });
      priceHtml += `</ul>`;
    }
    return priceHtml;
  }

  getProperties(properties) {
    let html = properties?.note
      ? `<span class="bc-cart__preorder">${properties?.note}</span>`
      : ``;
    for (const key in properties) {
      html += `<span style="display:none">${key}: ${properties[key]}</span>`;
    }
    return html;
  }
  checkFreeGiftItem(properties) {
    let is_free_gift = '';
    for (const key in properties) {
      if (properties[key] == 'free_gift') {
        is_free_gift = true;
        break;
      }
    }
    return is_free_gift;
  }

  getQuantity(a, b, qty, key, child, productTitle) {
    const t = (productTitle || '').replace(/"/g, '&quot;');
    if (a && b) {
      return `<div class="bc-cart__qty-wrapper">
          <span class="bc-cart__qty-minus" data-key="${key}" data-qty="${qty}" data-child="${child}" data-track="click" data-track-event="Cart - Quantity Decrease" data-track-detail="${t}" data-track-detail2="${qty - 1}">-</span>
          <span>${qty}</span>
          <span class="bc-cart__qty-plus" data-key="${key}" data-qty="${qty}" data-child="${child}" data-track="click" data-track-event="Cart - Quantity Increase" data-track-detail="${t}" data-track-detail2="${qty + 1}">+</span>
        </div>`;
    } else {
      return `<div class="bc-cart__qty-wrapper bc-right">
          <span>${qty}</span>
        </div>`;
    }
  }

  getSubtotalPrice(subtotal, total, discount) {
    fetch('/cart?view=ajax')
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        var temp = document.createElement('div');
        temp.innerHTML = data;
        document.querySelector('.bc-cart-prices-wraper').innerHTML =
          temp.querySelector('.bc-cart-prices-wraper').innerHTML;
        temp.querySelector('.cart-total-price span')
          ? (document.querySelector('.btn-sub-total').innerHTML =
              temp.querySelector('.cart-total-price span').innerHTML)
          : (document.querySelector('.btn-sub-total').innerHTML = '');
      });
  }

  getRemoveIcon() {
    // return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
    //   <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/>
    //   <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/>
    // </svg>`;
    return `<svg class="" aria-hidden="true" focusable="false" role="presentation">
            <use href="#icon-close">
          </use></svg>`;
  }

  getNotProductMessage() {
    return `<div class="bc-cart__not-products">
        Your cart is currently empty. <a href="/" target="_self">Click here</a> to continue shopping.
      </div><style>.cart-notification__links>.bc-cart__buttons-wrapper,.cart-notification__links>.bc-cart-prices-wraper{display:none}</style>`;
  }

  removeCartItem(event) {
    let el = event.target;
    let itemKey = el.getAttribute('data-key');
    let childID = el.getAttribute('data-child');

    if (!itemKey) return;
    this.changeItem(itemKey, childID);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.header?.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest('cart-notification') &&
      target.closest('#cart-icon-bubble') !== this.cartHref
    ) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  removeBtnInit() {
    const itemsRemoveButtons = document.querySelectorAll('span[role="button"]');
    itemsRemoveButtons?.length &&
      itemsRemoveButtons.forEach((btn) =>
        btn.addEventListener('click', this.removeCartItem.bind(this))
      );

    const minus = document.querySelectorAll('span.bc-cart__qty-minus');
    minus?.length &&
      minus.forEach((btn) =>
        btn.addEventListener('click', this.minusItem.bind(this))
      );

    const plus = document.querySelectorAll('span.bc-cart__qty-plus');
    plus?.length &&
      plus.forEach((btn) =>
        btn.addEventListener('click', this.plusItem.bind(this))
      );
  }
}

customElements.define('cart-notification', CartNotification);
